export default __webpack_public_path__ + "static/media/bee.df2f901e.mp3";